<button type="button" class="bell-btn" (click)="toggle($event)" aria-label="Notifications">
    <i class="pi pi-bell"></i>
    @if (unread() > 0) {
    <span class="bell-badge">{{ unread() > 99 ? '99+' : unread() }}</span>
    }
</button>

<p-popover #op styleClass="bell-popover">
    <div class="bell-panel">
        <div class="bell-head">
            <strong>Notifications</strong>
            @if (items().length) {
            <p-button label="Mark all read" [text]="true" size="small" (onClick)="markAllRead()" />
            }
        </div>

        @if (loading()) {
        <div class="bell-state"><i class="pi pi-spin pi-spinner"></i> Loading...</div>
        } @else if (!items().length) {
        <div class="bell-state"><i class="pi pi-check-circle"></i> No unread notifications</div>
        } @else {
        <div class="bell-list">
            @for (n of items(); track n.id) {
            <button type="button" class="bell-item unread" (click)="open(n)">
                <span class="dot on"></span>
                <span class="bell-item-body">
                    <span class="bell-title">{{ n.title || 'Notification' }}</span>
                    <span class="bell-msg">{{ n.message }}</span>
                    <span class="bell-time">{{ n.createdDate | indDate: true }}</span>
                </span>
            </button>
            }
        </div>
        }

        <!-- Footer: jump to the full history (read + unread) -->
        <button type="button" class="bell-foot" (click)="seeAll()">
            <i class="pi pi-list"></i> See all notifications
        </button>
    </div>
</p-popover>
